/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum AuthorisationStatus {
    Failed = "Failed",
    In_Progress = "InProgress",
    Partially_Succeeded = "PartiallySucceeded",
    Succeeded = "Succeeded"
}